import moment from 'moment';
import { FRONTEND_DATE_FORMAT } from 'providence-types';

export const getDateStringOrEmptyString = (value: string = ''): string =>
  value ? moment(value).format(FRONTEND_DATE_FORMAT) : '';
